module.exports = __webpack_public_path__ + "img/2.905e6649.jpg";